'use strict';

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/Edit.tsx
var SvgEdit = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M16.57 3.13 18 1.7a2 2 0 0 1 2.83 0l1.41 1.42a2 2 0 0 1 0 2.82l-1.41 1.42-.36.35-8.95 8.96a1 1 0 0 1-.57.28l-3.3.47a1 1 0 0 1-1.13-1.13l.47-3.3a1 1 0 0 1 .28-.56l8.96-8.96.36-.35Zm4.6 1.76a.5.5 0 0 0 0-.7l-1.41-1.42a.5.5 0 0 0-.71 0l-1.06 1.06 2.12 2.12 1.06-1.06Zm-4.24 0-8.49 8.49-.35 2.47 2.47-.35 8.49-8.48-2.12-2.13ZM6.73 3.36h5.22a.75.75 0 1 1 0 1.5H6.77c-.85 0-1.44 0-1.9.04-.45.03-.7.1-.9.2-.42.22-.76.56-.98.98-.1.2-.17.45-.2.9-.04.46-.04 1.05-.04 1.9v8.35c0 .85 0 1.44.04 1.9.03.45.1.7.2.9.22.42.56.76.98.98.2.1.45.16.9.2.46.04 1.05.04 1.9.04h8.35c.85 0 1.44 0 1.9-.04.45-.04.7-.1.9-.2.42-.22.76-.56.98-.98.1-.2.17-.45.2-.9.04-.46.04-1.05.04-1.9v-5.18a.75.75 0 0 1 1.5 0v5.21c0 .8 0 1.46-.04 1.99a3.82 3.82 0 0 1-.37 1.46c-.35.7-.92 1.27-1.63 1.63-.44.23-.92.32-1.46.37-.53.04-1.18.04-1.99.04H6.74c-.8 0-1.46 0-1.99-.04a3.82 3.82 0 0 1-1.46-.37 3.73 3.73 0 0 1-1.63-1.63 3.82 3.82 0 0 1-.37-1.46c-.04-.53-.04-1.18-.04-1.99V8.85c0-.81 0-1.46.04-1.99.05-.54.14-1.02.37-1.46a3.8 3.8 0 0 1 1.63-1.64c.44-.22.92-.31 1.46-.36.53-.04 1.18-.04 1.99-.04Z" }));
var Edit_default = SvgEdit;

module.exports = Edit_default;
